import { createStore } from '../../utils/store/store';
import { pageInitialData } from '../../utils/pageInitialdata';
import { BookStoreProps } from './PageContext.types';
import { BookActions } from './bookStoreActions';

const bookStore = createStore<BookStoreProps>(pageInitialData, BookActions);

export { bookStore };
